import * as t from "io-ts";
export const deprecatedEndpointUsageEntryT = t.strict({
    orgName: t.string,
    driverName: t.string,
    phone: t.string,
    language: t.string,
    endpoint: t.string,
    lastUseDate: t.string,
});
export const deprecatedEndpointUsageT = t.array(deprecatedEndpointUsageEntryT);
//# sourceMappingURL=deprecated-endpoint-usage.js.map